// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65d1c759","732":"67d030aa","977":"2ccf65ea"}[chunkId] + ".chunk.js";
};